import React, { useEffect, useState } from 'react';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleFilled,
} from '@ant-design/icons';
import { Typography, Button, Col, Divider, Row, Tooltip } from 'antd';
import { STATUS } from '../../../../redux/constants';
import styles from './subscription.module.sass';
import { changeTitle } from '../../../../redux/actions/app';
import { useDispatch } from 'react-redux';
import ProgressCircle from '../../../../shared-components/ProgressCircle';
import cx from 'classnames';
import moment from 'moment-timezone';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';

function Subscription(props) {
  const { status, user, organization } = props;
  const { Title } = Typography;

  const [subscriptionData, setSubscriptionData] = useState({});
  const [requestLeft, setRequestLeft] = useState(0);
  const [requestLimit, setRequestLimit] = useState(0);
  const [profileLimit, setProfileLimit] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Subscription - Silent Push';
    props.loadUser();
    // props.loadOrganization();
  }, []);

  useEffect(() => {
    if (status === STATUS.LOADED) {
      setSubscriptionData(user.subscription_info);
      setRequestLeft(
        subscriptionData?.total_requests_left
          ? subscriptionData.total_requests_left ?? 0
          : 0,
      );
      setRequestLimit(
        subscriptionData?.requests_limit
          ? subscriptionData.requests_limit ?? 0
          : 0,
      );
      setProfileLimit(
        subscriptionData?.threat_ranking_profile_limit
          ? subscriptionData.threat_ranking_profile_limit ?? 0
          : 0,
      );
    }
  }, [user]);

  dispatch(changeTitle('Subscription', null));

  const isLoadingFinished = status === STATUS.LOADED || STATUS.IDLE;

  return isLoadingFinished ? (
    <div className={styles.subscription}>
      <div className={styles.title}>
        <div className={styles.text}>
          {user?.subscription_plan_name && (
            <>
              <Title>{user.subscription_plan_name}</Title>
              <Title className={styles.dot} level={2}>
                •{' '}
              </Title>
            </>
          )}
          {user?.organisation && <Title level={2}>{user.organisation}</Title>}
        </div>
        <Button
          type="primary"
          role="button"
          target="_blank"
          href="mailto:sales@silentpush.com?subject=Subscription plan upgrade."
        >
          Upgrade my plan
        </Button>
      </div>
      <Divider className={cx(styles.divider, styles.first)} />

      <div className={styles.limits}>
        <Row justify="center">
          <Col xs={2} sm={4} md={6} lg={8} xl={{ span: 9, push: 2 }}>
            <Title level={3}>{requestLimit}</Title>
            <p>Requests / day</p>
          </Col>

          <Col xs={20} sm={16} md={12} lg={8} xl={6}>
            <ProgressCircle
              percent={Math.round(requestLeft / (requestLimit / 100))}
              amount={requestLeft}
            ></ProgressCircle>
          </Col>

          <Col xs={2} sm={4} md={6} lg={8} xl={{ span: 9, pull: 2 }}>
            <Title level={3}>{profileLimit}</Title>
            <p>Filter profiles limit</p>
          </Col>
        </Row>
      </div>
      <Divider className={styles.divider} />

      <div className={styles.preferences}>
        <Row justify="center">
          <Col
            className={styles.column}
            xs={24}
            lg={12}
            xl={{ span: 8, push: 1 }}
          >
            <p>Creation date: </p>
            <Title level={3}>
              {subscriptionData?.creation_date
                ? moment(subscriptionData?.creation_date)
                    .utc()
                    .format('YYYY-MM-DD')
                : '-'}
            </Title>
          </Col>

          <Col className={styles.column} xs={24} lg={12} xl={8}>
            <p>Expiration date: </p>
            <Title level={3}>
              {subscriptionData?.expiration_date
                ? moment(subscriptionData?.expiration_date)
                    .utc()
                    .format('YYYY-MM-DD')
                : '-'}
            </Title>
          </Col>

          <Col
            className={cx(styles.column, styles.checks)}
            xs={24}
            lg={24}
            xl={{ span: 8, pull: 1 }}
          >
            <p>
              Custom feeds:&nbsp;
              <Tooltip
                className={styles.tooltip}
                placement="bottom"
                title="Subscription allows you to create custom feeds"
              >
                <InfoCircleFilled />
              </Tooltip>
            </p>
            <Title level={3}>
              {subscriptionData.can_create_custom_feed ? (
                <CheckCircleOutlined className={styles.icon_check} />
              ) : (
                <CloseCircleOutlined className={styles.icon_close} />
              )}
            </Title>
          </Col>
        </Row>
      </div>
    </div>
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}

export default Subscription;
